import {all, call, fork, put, takeEvery} from 'redux-saga/effects';
import {SETUP_LOAD, SETUP_RELOAD,} from '../constants/Setup';
import {endLoading, save, startLoading} from "../actions/Setup";

import SetupService from 'model/service/SetupService';
import IRestServiceSetupResponse from "../../model/interface/api/IRestServiceSetupResponse";
import Utils from "../../utils";
import {loadTheme} from "../actions/Theme";
import {Action} from "redux";
import {update} from "../actions/StreamEvents";

interface ReloadAction extends Action {
	cache: boolean
	loading?: boolean
}

export function* setupLoad() {
  	yield takeEvery(SETUP_LOAD, function* () {
		yield put(startLoading());
		const response: IRestServiceSetupResponse = yield call(SetupService.load)
		yield put(save(response));
		yield response.user.theme && put(loadTheme(response.user.theme));
		yield put(endLoading());
	});
}
export function* setupReload() {
  	yield takeEvery<ReloadAction>(SETUP_RELOAD, function* (payload) {
		if (payload.loading){
			yield put(startLoading())
		}
		yield put(update({setup: undefined}))
		payload.loading && !payload.cache && localStorage.removeItem('setup')
		payload.loading && localStorage.removeItem('user-setup')
		payload.loading && Utils.cleanStorage()
		const response: IRestServiceSetupResponse = yield call(() => SetupService.load(payload.cache))
		yield put(save(response));
		if (payload.loading){
			yield put(endLoading())
		}
	});
}

export default function* rootSaga() {
  yield all([
		fork(setupLoad),
		fork(setupReload)
  ]);
}
